// "Salta al contenuto" — visible only when keyboard-focused. Positioned at
// the top of the document so screen-reader / keyboard-only users can bypass
// the TopBar repetition between routes. Targets #main-content which the
// Surface atom mounts as the page <main>.

export function SkipLink() {
  return (
    <a
      href="#main-content"
      className="absolute left-3 top-3 z-50 -translate-y-20 rounded-full bg-rame px-4 py-2 font-sans text-sm text-[#FDFBF7] shadow-elevated transition-transform duration-150 focus-visible:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rame focus-visible:ring-offset-2 focus-visible:ring-offset-paper"
    >
      Salta al contenuto
    </a>
  );
}
